import hero from "../images/about_hero.png";
import sc_logo_desk from "../images/logo_home_mobile.png";
import believe_hero from "../images/about_believe.png";
import values_hero from "../images/about_values.png";
// import story_hero from "../images/about_story.png";
import women_hero from "../images/about_circleOfHands.png";
import approach_hero from "../images/about_approach.png";
import impact1_hero from "../images/about_impact1.jpg";
import impact2_hero from "../images/about_impact2.jpg";
import values_icon1 from "../images/values_icon1.svg";
import values_icon2 from "../images/values_icon2.svg";
import values_icon3 from "../images/values_icon3.svg";
import values_icon4 from "../images/values_icon4.svg";

import Navbar from "../sections/Navbar.js";
import Footer from "../sections/Footer.js";
import { useRef, useState, useCallback } from "react";
import useScrollToSection from "../hooks/useScrollToSection";
import YouTubeVideo from "../components/YouTubeVideo";
import TimelineScroller from "../components/TimelineScroller";
import HeroMorph from "../components/HeroMorph";
import SectionReveal from "../components/SectionReveal";

// ── Toggle: set to true for SVG morph animation, false for original PNG hero ──
const showHeroMorph = false;

// ── Toggle: set to true for scroll-triggered fade-up on content sections ──
const showSectionReveal = true;

const About = () => {
  const aboutPageRef = useRef();
  const sisterCircleComponent = useRef();
  const visionComponent = useRef();
  const missionComponent = useRef();
  const valuesComponent = useRef();
  const womenComponent = useRef();
  const impactComponent = useRef();
  const storyComponent = useRef();

  // Track navbar overlay state for logo z-index toggle
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  // Timeline events data (will be CMS-driven later)
  const timelineEvents = [
    {
      year: 1981,
      description: "A group of determined local health and community workers set up the Maternity Services Liaison Scheme (MSLS) with support from the Tower Hamlets Association for Racial Justice."
    },
    {
      year: 1994,
      description: "We officially became Women's Health and Family Services to more accurately reflect the breadth of women's health support programmes we offer."
    },
    {
      year: 2010,
      description: "Our flagship Maternity Mates programme officially starts operating in Tower Hamlets, supporting women in challenging circumstances with prenatal, labour and postnatal support."
    },
    {
      year: 2014,
      description: "Our Female Genital Cutting Community Health Champions programme begins operating in Tower Hamlets."
    },
    {
      year: 2015,
      description: "Maternity Mates expands into Newham."
    },
    {
      year: 2017,
      description: "Maternity Mates expands into Waltham Forest."
    },
    {
      year: 2022,
      description: "We launched Healing Conversations, providing support and healing following pregnancy loss, birth trauma or infant loss."
    },
    {
      year: 2023,
      description: "Women's Health and Family Services becomes Sister Circle, continuing to follow in the footsteps of our founders, supporting women to lead healthy lives."
    },
    // {
    //   year: 2024,
    //   description: "Maternity Mates expansion to Southwark."
    // },
    {
      year: 2025,
      description: "Maternity Mates expansion to Croydon."
    },
    {
      year: 2026, 
      description: "We celebrate 45 years of supporting women when they need it most."
    }
  ];


  //  { name: "About Sister Circle", url: "/about-us/#about-sister-circle" },
  //       { name: "Our vision", url: "/about-us/#our-vision" },
  //       { name: "Our mission", url: "/about-us/#our-mission" },
  //       { name: "Our values", url: "/about-us/#our-values" },
  //       { name: "The women we support", url: "/about-us/#the-women-we-support" },
  //       { name: "Our impact", url: "/about-us/#our-impact" },
  //       { name: "Our story", url: "/about-us/#our-story" },

  // Use custom hook to handle URL-based scrolling to sections
  useScrollToSection({
    "about-sister-circle": sisterCircleComponent,
    "our-vision": visionComponent,
    "our-mission": missionComponent,
    "our-values": valuesComponent,
    "the-women-we-support": womenComponent,
    "our-impact": impactComponent,
    "our-story": storyComponent,
  });

  return (
    <div className="">
      <Navbar whichRef={sisterCircleComponent} currentPage="about" onOverlayActive={handleOverlayActive} />
      {/* ---------------------------------------------------------------------------------------------------------------
    ---------------------------------------OPENING About us content--------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#DCB1FA]">
        <div className="mx-auto max-w-[1240px]">
          <a href="/" className="0">
            <img
              src={sc_logo_desk}
              className={`xs:mt-6  md:ml-6 s:ml-12 xs:ml-8   xl:w-[150px] lgx:w-[140px] lg:w-[120px] md800:w-[110px] md:w-[100px] sm:w-[110px] ss:w-[110px] s:w-[100px] xs:w-[90px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
              alt="secret-circle-logo"
            />
          </a>
          <div className="flex  md:flex-row items-center w-full bg-[#DCB1FA] overflow-hidden">
            <div className="max-w-[1240px]  absolute md:mb-0 md:mt-0 w-[100%] ">
              <h1 className="xs:z-10 xs:relative md:static md:ml-0 xs:text-left md:text-center xs:mb-0  xs:mr-0  xs:ml-[2rem] s:ml-[3rem] sm:ml-[4rem]  md:mt-0  font-sans antialiased mds:text-[4.8rem] mds:leading-[2.2rem] s:text-[3rem] xss:text-[2.8rem] xss:leading-[2.2rem] align-middle text-[#b24029]">
                About us
              </h1>
            </div>

            <div className=" md:mt-0  md:mb-0 w-[100%]  ">
              {/* Toggle showHeroMorph (above) between SVG morph animation and original PNG */}
              {showHeroMorph ? (
                <HeroMorph
                  className="xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0 xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] float-right"
                />
              ) : (
                <img
                  src={hero}
                  className="xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0 xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] hero-img float-right"
                  alt="hero"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- About ---------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={sisterCircleComponent} className="bg-[#ffe1d9]">
        <div
          ref={aboutPageRef}
          className="mx-auto max-w-[1240px] responsive-maternity-pt"
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">
            <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
              <h1 className="module-headlineL  w-[100%]">
                About<br className="hidden md:block"></br> Sister Circle
              </h1>
              <p className="module-bodycopyL w-[100%]">
                Putting Women’s Health First.
                <br /><br />
                Sister Circle is a multicultural, women-led charity dedicated to advancing health equity
                and justice for women from diverse communities living with complex challenges. Our
                volunteers and staff, many of whom have lived experiences similar to those of the
                women we serve, build trusted relationships and provide holistic support.
              </p>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-[5vh] xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">
              
              <img
                src={believe_hero}
                className=" max-h-[671px] h-[auto] mx-auto"
                alt="hero"
              />
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our Vision --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#ffe1d9]">
        <div
          ref={visionComponent}
          className="mx-auto max-w-[1240px] responsive-maternity-pt"
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9]  overflow-hidden">
            <div className="  md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-[5vh] xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={values_hero}
                className=" xs:mx-auto max-h-[671px]  block  "
                alt="healing_image"
              />
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className="  xs:mb-[0vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              <h1 className="module-headline  w-[95%]">
                Our Vision
              </h1>
              <p className="module-bodycopy  w-[95%]">
                A future where women’s voices and lived experiences are heard, barriers dismantled,
                and health systems transformed, so every woman can thrive.
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

     {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our Mission ---------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={missionComponent} className="bg-[#ffe1d9]">
        <div
        
          className="mx-auto max-w-[1240px] responsive-maternity-pt "
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">
            <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
              <h1 className="module-headlineL  w-[100%]">
                Our<br className="hidden md:block"></br> Mission
              </h1>
              <p className="module-bodycopyL w-[100%]">
                We walk alongside women to create change.
                <br /><br />
                We build trusted relationships that create sustainable transformation for women’s
                wellbeing. Our work is rooted in the lived experience of every woman, during their
                health journeys. We meet women where they are, offering a trusting, safe and
                supportive space at the times when they need it the most. With person-centred support,
                advocacy, and community partnerships, women make their choices and determine their
                own care regardless of their circumstances.
                <br /><br />
                We do this by:
                <br /><br />
                <ol className="list-disc pl-4">
                  <li className="pb-3">Maternity Mates: Support during pregnancy, birth and in the early days with a new baby.</li>
                  <li className="pb-3">Her Health: Specialist support following gender-based violence.</li>
                  <li className="pb-0">Healing Conversations: Maternal Mental Health peer support and long-term trauma counselling in community languages.</li>
                </ol>
          
              </p>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-[5vh] xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">
             <img
                src={approach_hero}
                className=" xs:mx-auto max-h-[671px] "
                alt="healing_image"
              />
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>




     {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our Values ---------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={valuesComponent} className="bg-[#ffe1d9]">
        <div
        
          className="mx-auto max-w-[1240px] responsive-maternity-pt "
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:items-center md:items-start  mx-auto xs:w-4/5 md:w-full bg-[#ffe1d9] md:min-h-[462px] overflow-hidden ">
            <div className=" xs:mb-[0vh] xs:mt-[0vh] md:mt-0  md:mb-0  w-full   x1270:ml-[4.5rem] md:ml-[1.5rem] ">
              <h1 className="module-headlineL w-[100%]">
                Our Values
              </h1>
              {/* <p className="module-bodycopyL w-[100%]">
                Putting our beneficiaries and the services we provide at the heart of what we do, we embody these values:
              </p> */}
              <div className="grid md:grid-cols-2 xs:grid-cols-1 gap-x-10 gap-y-8 mt-8 w-[100%]">
                <div>
                  <img src={values_icon1} alt="Trust and Integrity" className="h-auto mb-4" style={{ width: 'clamp(40px, calc(30.43px + 3.19vw), 70px)' }} />
                  <h3 className="module-subhead-values mb-4">Trust and Integrity</h3>
                  <p className="module-bodycopy-values">
                  We create safe environments and act with accountability by doing what we say. We uphold the organisation&#39;s values and behaviours by fostering professional relationships that nurture and develop both the organisation and the women we serve. We hold ourselves and others to account, because trust is earned not assumed. We take responsibility for our work, actions and behaviour, building independence and self-efficiency and trusted relationships to raise a movement for change.
                  </p>
                </div>
                <div>
                  <img src={values_icon2} alt="Growth and learning" className="h-auto mb-4" style={{ width: 'clamp(40px, calc(30.43px + 3.19vw), 70px)' }} />
                  <h3 className="module-subhead-values mb-4">Growth and learning</h3>
                  <p className="module-bodycopy-values">
                  We strive for opportunity and excellence by continuously developing. We seek growth through collaboration and initiative, aiming to deliver and develop both ourselves and the organisation. We ask how we can improve, grow and achieve better for our beneficiaries. We support each other’s self-development, listen and show respect when people are sharing. Together, we are committed to learning and building resilience.
                  </p>
                </div>
                <div>
                  <img src={values_icon3} alt="Fearlessness – Speaking up" className="h-auto mb-4" style={{ width: 'clamp(40px, calc(30.43px + 3.19vw), 70px)' }} />
                  <h3 className="module-subhead-values mb-4">Fearlessness – Speaking up</h3>
                  <p className="module-bodycopy-values">
                  We are a reputable and trusted organisation that does the right thing by speaking up and challenging social norms and indifferences, exploring new ideas to create meaningful change. We amplify voices that are often unheard to promote equity in access to health systems, and raise uncomfortable but necessary topics, in thoughtful, respectful ways.
                  </p>
                </div>
                <div>
                  <img src={values_icon4} alt="Working collaboratively – Change and understanding" className="h-auto mb-4" style={{ width: 'clamp(40px, calc(30.43px + 3.19vw), 70px)' }} />
                  <h3 className="module-subhead-values mb-4">Working collaboratively – Change and understanding</h3>
                  <p className="module-bodycopy-values">
                  We adapt to women’s needs, teaching and motivating each other and sharing expertise. We celebrate differences while working alongside our beneficiaries towards a common vision. We respectfully listen to our community and each other, working with trust as we step up to achieve our goals. We celebrate our differences and value others by creating an environment that is inclusive and welcoming to everyone. We demonstrate empathy and understanding for others through role modelling equity.
                  </p>
                </div>
              </div>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- The women we support ---------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={womenComponent} className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-[5vh] md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={women_hero}
                className=" xs:mx-auto max-h-[671px] block "
                alt="circle of hands"
              />
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              <h1 className="module-headline  w-[95%]">
                The women<br className="hidden md:block"></br> we support
              </h1>
              <p className="module-bodycopy w-[95%]">
                The remarkable women we support find themselves in difficult circumstances of multiple complexities – no support network, living in poor temporary accommodation, newly arrived in the UK with little English, no knowledge of the maternity and women’s healthcare systems, homeless, having experienced gender violence.
                <br />
                <br />
                Each woman deserves to have good mental, physical and social wellbeing and to receive support in rebuilding a better life for herself and her family.
                <br />
                <br />
                Anyone who uses our service can expect to:
                <br />
                <br />
                <ol className="list-disc pl-4">
                  <li className="pb-3">
                    Easily access healthcare that meets her needs
                  </li>
                  <li className="pb-3">Be listened to</li>
                  <li className="pb-3">Be respected</li>
                  <li className="pb-0">Be treated with empathy and kindness</li>
                </ol>
              </p>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>




      
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our impact ---------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={impactComponent} className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt pb-24 ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] overflow-hidden">

            {/* Left column — desktop */}
            <div className="module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
              <h1 className="module-headlineL w-[100%]">
                Our impact
              </h1>
              <p className="module-bodycopyL w-[100%]">
                Since 2010, Maternity Mates have supported over 1,000 women and their families with emotional and practical help to ensure better birth outcomes. We also work with survivors of Female Genital mutilation/Cutting (FGM/C), and advocate for an end to the practice through outreach and education.
                <br></br><br></br>
                {/* Desktop only — hidden on mobile */}
                <span className="xs:hidden md:inline">
                  Click play to listen to the story of a single mother, who was desperately in need of support during her second pregnancy. Sister Circle came to her aid, providing her with a Maternity Mate who was by her side during the birth and those critical first few months.
                  <br></br><br></br>
                  Click on the video to watch real stories of women who've experienced FGM/C and their experience of accessing trauma counselling to see just how crucial this can be in their healing journey.
                </span>
              </p>
            </div>

            {/* Right column */}
            <div className="md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-[0vh] xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">

              {/* Mobile only — above video 1 */}
              <p className="module-bodycopyL md:hidden mx-auto w-[90%] ">
                Click play to listen to the story of a single mother, who was desperately in need of support during her second pregnancy. Sister Circle came to her aid, providing her with a Maternity Mate who was by her side during the birth and those critical first few months.<br/><br/>
              </p>

              <YouTubeVideo
                videoId="pjY_b8iov6A"
                thumbnail={impact1_hero}
                title="Maternity Mate story"
                className="max-h-[671px] max-w-[670px] mx-auto"
              />

              {/* Mobile only — above video 2 */}
              <p className="module-bodycopyL md:hidden xs:mt-[5vh] mx-auto w-[90%] ">
                Click on the video to watch real stories of women who've experienced FGM/C and their experience of accessing trauma counselling to see just how crucial this can be in their healing journey.<br/><br/>
              </p>

              <div className="xs:mt-0 md:mt-8">
                <YouTubeVideo
                  videoId="kqtBXfzbul0"
                  thumbnail={impact2_hero}
                  title="FGM/C trauma counselling stories"
                  className="max-h-[671px] max-w-[670px] mx-auto"
                />
              </div>

            </div>
          </div>
          </SectionReveal>
        </div>
      </div>





      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Our story --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#ff794e] overflow-hidden ">
        <div className="bg-[#ff794e] ">
          <div ref={storyComponent} className="mx-auto max-w-[1240px] ">
            {/* Interactive Timeline Scroller with integrated title/description */}
            <TimelineScroller 
              events={timelineEvents}
              title="Our story"
              description="Our charity began as a way to help Bangladeshi and Somalian women in Tower Hamlets access maternity health services and quality healthcare."
              startYear={2023}
              hintYear={2023}
            />
          </div>
        </div>
      </div>
      {/* --------------------------------------------------content 5 end--------------------------------------------------- */}
      <Footer />
    </div>
  );
};

export default About;
